export default "__VITE_ASSET__DDo_6W2u__";